import style from "./Icon.module.css";

function Icons({ icon, iconClick }) {



  return <div className={style.iconWrapper} onClick={iconClick}>{icon}</div>;
}
export default Icons;
